import { CountryDepartment } from '@app/models/country-department';
import { Action } from '@ngrx/store';

interface CountryDepartmentCreationData {
    name: string;
    BusinessId: number;
    CountryId: number;
    code: string;
    level: number;
    ParentId: number;
}

export enum CountryDepartmentActionTypes {
    Load = '[API] Load Country Departments',
    LoadSuccess = '[API] Load Country Departments Success',
    LoadFail = '[API] Load Country Departments Fail',

    LoadbyProduct = '[API] Load by Products Country Departments',
    LoadbyProductSuccess = '[API] Load by Products Country Departments Success',
    LoadbyProductFail = '[API] Load by Products Country Departments Fail',

    Clear = '[CountryDepartment] Clear Country Department',
    ClearSuccess = '[CountryDepartment] Clear Country Department',
    ClearFail = '[CountryDepartment] Clear Country Department',

    Search = '[Search] Search country department',
    SearchSuccess = '[Search] Search country department success',
    SearchFail = '[Search] Search country department fail',
    ClearSearch = '[Search] Clear search country department',

    Create = '[API] Create Country Department',
    CreateSuccess = '[API] Create Country Department Success',
    CreateFail = '[API] Create Country Department Fail',

    Update = '[CountryDepartment] Update country department',
    UpdateSuccess = '[CountryDepartment] Update country department success',
    UpdateFail = '[CountryDepartment] Update country department fail',

    Delete = '[CountryDepartment] Delete country department',
    DeleteSuccess = '[CountryDepartment] Delete country department success',
    DeleteFail = '[CountryDepartment] Delete country department fail',
    LoadPlanner = '[CountryDepartment] Load Country department to planner',
    LoadPlannerSuccess = '[CountryDepartment] Load Country department to planner success',
    LoadPlannerFail = '[CountryDepartment] Load Country department to planner fail',
    Void = '[VOID] Void action that should not be handled',

    LoadById = '[API] Load by Id Country Department',
    LoadByIdSuccess = '[API] Load by Id Country Department success',
    LoadByIdFail = '[API] Load by Id Country Department fail',

    updateHierarchy ='[Department] update hierarchy',
    updateHierarchySuccess ='[Department] update hierarchy success',
    updateHierarchyFail ='[Department] update hierarchy fail',
}

export class Load implements Action {
    readonly type = CountryDepartmentActionTypes.Load;
    constructor(public FollowId: number, public dataFilter?: any) { }
}

export class LoadSuccess implements Action {
    readonly type = CountryDepartmentActionTypes.LoadSuccess;
    constructor(public countryDepartments: any[]) { }
}

export class LoadFail implements Action {
    readonly type = CountryDepartmentActionTypes.LoadFail;
    constructor(public error: any) { }
}

export class LoadbyProduct implements Action {
    readonly type = CountryDepartmentActionTypes.LoadbyProduct;
    constructor(public FollowId: number, public dataFilter?: any) { }
}

export class LoadbyProductSuccess implements Action {
    readonly type = CountryDepartmentActionTypes.LoadbyProductSuccess;
    constructor(public countryDepartments: CountryDepartment[]) { }
}

export class LoadbyProductFail implements Action {
    readonly type = CountryDepartmentActionTypes.LoadbyProductFail;
    constructor(public error: any) { }
}

export class Clear implements Action {
    readonly type = CountryDepartmentActionTypes.Clear;
    constructor() { }
}

export class ClearSuccess implements Action {
    readonly type = CountryDepartmentActionTypes.ClearSuccess;
    constructor(public data: any) { }
}

export class ClearFail implements Action {
    readonly type = CountryDepartmentActionTypes.ClearFail;
    constructor(public error: any) { }
}

export class Search implements Action {
    readonly type = CountryDepartmentActionTypes.Search;
    constructor(public data: any, public FollowId: any) { }
}

export class SearchSuccess implements Action {
    readonly type = CountryDepartmentActionTypes.SearchSuccess;
    constructor(public countryDepartmentsIds: any[]) { }
}

export class SearchFail implements Action {
    readonly type = CountryDepartmentActionTypes.SearchFail;
    constructor(public error: any) { }
}

export class ClearSearch implements Action {
    readonly type = CountryDepartmentActionTypes.ClearSearch;
    constructor() { }
}

export class Create implements Action {
    readonly type = CountryDepartmentActionTypes.Create;
    constructor(public data: CountryDepartmentCreationData) { }
}

export class CreateSuccess implements Action {
    readonly type = CountryDepartmentActionTypes.CreateSuccess;
    constructor(public countryDepartment: CountryDepartment) { }
}

export class CreateFail implements Action {
    readonly type = CountryDepartmentActionTypes.CreateFail;
    constructor(public error: any) { }
}

export class Update implements Action {
    readonly type = CountryDepartmentActionTypes.Update;
    constructor(public id: number, public countryDepartment: any) { }
}
export class UpdateFail implements Action {
    readonly type = CountryDepartmentActionTypes.UpdateFail;
    constructor(public error: any) { }
}

export class UpdateSuccess implements Action {
    readonly type = CountryDepartmentActionTypes.UpdateSuccess;
    constructor(public id: number, public countryDepartment: any) { }
}

export class Delete implements Action {
    readonly type = CountryDepartmentActionTypes.Delete;
    constructor(public id: number) { }
}
export class DeleteFail implements Action {
    readonly type = CountryDepartmentActionTypes.DeleteFail;
    constructor(public error: any) { }
}

export class DeleteSuccess implements Action {
    readonly type = CountryDepartmentActionTypes.DeleteSuccess;
    constructor(public CountryDepartmentId: any) { }
}

export class Void implements Action {
    readonly type = CountryDepartmentActionTypes.Void;
    constructor() { }
}

export class LoadPlanner implements Action {
    readonly type = CountryDepartmentActionTypes.LoadPlanner;
    constructor(public FollowId: number, public dataFilter?: any) { }
}

export class LoadPlannerSuccess implements Action {
    readonly type = CountryDepartmentActionTypes.LoadPlannerSuccess;
    constructor(public countryDepartments: any[]) { }
}

export class LoadPlannerFail implements Action {
    readonly type = CountryDepartmentActionTypes.LoadPlannerFail;
    constructor(public error: any) { }
}

export class LoadById implements Action {
    readonly type = CountryDepartmentActionTypes.LoadById;
    constructor(public FollowId: number, public dataFilter?: any) { }
}

export class LoadByIdSuccess implements Action {
    readonly type = CountryDepartmentActionTypes.LoadByIdSuccess;
    constructor(public CategoryId: any, public data: any) { }
}

export class LoadByIdFail implements Action {
    readonly type = CountryDepartmentActionTypes.LoadByIdFail;
    constructor(public error: any) { }
}

export class updateHierarchy implements Action {
    readonly type = CountryDepartmentActionTypes.updateHierarchy;
    constructor(){}
}

export class updateHierarchySuccess implements Action {
    readonly type = CountryDepartmentActionTypes.updateHierarchySuccess;
    constructor(public data?: any){}
}

export class updateHierarchyFail implements Action {
    readonly type = CountryDepartmentActionTypes.updateHierarchyFail;
    constructor(public error?: any){}
}

export type CountryDepartmentActionsUnion =
    | Load
    | LoadSuccess
    | LoadFail
    | LoadbyProduct
    | LoadbyProductSuccess
    | LoadbyProductFail
    | Clear
    | ClearSuccess
    | ClearFail
    | Search
    | SearchSuccess
    | SearchFail
    | ClearSearch
    | Create
    | CreateSuccess
    | CreateFail
    | Update
    | UpdateSuccess
    | UpdateFail
    | Delete
    | DeleteSuccess
    | DeleteFail
    | Void
    | LoadPlanner
    | LoadPlannerSuccess
    | LoadPlannerFail
    | LoadById
    | LoadByIdSuccess
    | LoadByIdFail
    | updateHierarchy
    | updateHierarchySuccess
    | updateHierarchyFail;
